module.exports = __webpack_public_path__ + "assets/img/fire-idle.4ab956a1.png";